import React, { useEffect } from "react";
import { Modal, Form, message } from "antd";
import CustomListItemForm from "./CustomListItemForm";
import { WebApiCustomListsDtoCustomListItemDto, WebApiCustomListsDtoUpdateCustomListItemDto, WebApiMemberDtoMemberDto, WebApiModelsCustomListField } from "../../Repository/eventbookyapi";
import { UiControlType } from "../../Types/UiControlType";
import { CustomListItemService } from "../../Services/CustomListItemService";
import dayjs from "dayjs";

interface CustomListEditModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    customFields: WebApiModelsCustomListField[];
    item: WebApiCustomListsDtoCustomListItemDto;
}

const CustomListEditModal: React.FC<CustomListEditModalProps> = ({
    open,
    onClose,
    onSuccess,
    customFields,
    item
}) => {
    const [form] = Form.useForm();
    const [lookupOptions, setLookupOptions] = React.useState<WebApiCustomListsDtoCustomListItemDto[]>([]);

    useEffect(() => {
        if (open && item) {
            const initialValues: any = {};
            const lookupFields = customFields.filter(f => f.uiControl === UiControlType.Lookup);
            const fetchLookups = async () => {
                const lookups: WebApiCustomListsDtoCustomListItemDto[] = [];
                await Promise.all(customFields.map(async (field: WebApiModelsCustomListField) => {
                    let value = item.fieldValues?.find(fv => String(fv.fieldId) === String(field.id))?.fieldValue;
                    if (field.uiControl === UiControlType.Date && value && !dayjs.isDayjs(value)) {
                        value = dayjs(value);
                    }
                    if (field.uiControl === UiControlType.Lookup) {
                        value = value !== undefined && value !== null ? String(value) : undefined;
                        if (field.lookupListId) {
                            lookups.push(...(await CustomListItemService.GetItems(field.lookupListId) || []));
                        }
                    }
                    initialValues[String(field.id)] = value;
                }));
                setLookupOptions(lookups);
                form.setFieldsValue(initialValues);
            };
            fetchLookups();
        }
        // eslint-disable-next-line
    }, [open, item, customFields, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            console.log(values);
            const updateDto: WebApiCustomListsDtoUpdateCustomListItemDto = {
                id: item.id,
                fieldValues: Object.entries(values)
                    .filter(([_, fieldValue]) => fieldValue !== undefined && fieldValue !== null && fieldValue !== "")
                    .map(([fieldId, fieldValue]) => ({
                        fieldId: Number(fieldId),
                        fieldValue: fieldValue != null ? fieldValue : ""
                    })),
            };
            await CustomListItemService.UpdateCustomListItem(item.id!, updateDto);
            message.success("Uppdaterad!");
            onClose();
            if (onSuccess) onSuccess();
        } catch (e) {
            message.error("Kunde inte uppdatera posten.");
        }
    };

    return (
        <Modal
            title="Redigera post"
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            okText="Spara"
            cancelText="Avbryt"
            destroyOnClose
        >
            <CustomListItemForm
                form={form}
                customFields={customFields}
                mode="edit"
                lookupOptions={lookupOptions}
            />
        </Modal>
    );
};

export default CustomListEditModal;
